import { useLingui } from '../../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import Button from '../../../components/atoms/Button.mjs';
import Column from '../../../components/atoms/Column.mjs';
import Typography from '../../../components/atoms/Typography.mjs';
import ButtonColumn from '../../../components/molecules/ButtonColumn.mjs';
import { useGlobalReducer, AppScreens } from '../../GlobalContextProvider.mjs';
import { CryptoWalletButtons } from './WalletButtons.mjs';

const OtherCryptoWallets = ()=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    const [, dispatch] = useGlobalReducer();
    return /*#__PURE__*/ React__default.createElement(Column, {
        gap: 6
    }, /*#__PURE__*/ React__default.createElement(Typography, {
        variant: "header"
    }, $__i18n._({
        id: "crypto.continueWithOtherWallet.title"
    })), /*#__PURE__*/ React__default.createElement(ButtonColumn, null, /*#__PURE__*/ React__default.createElement(CryptoWalletButtons, {
        type: "other"
    }), /*#__PURE__*/ React__default.createElement(Button, {
        variant: "ghost",
        onClick: ()=>dispatch({
                type: 'transition',
                screen: AppScreens.Main
            })
    }, $__i18n._({
        id: "button.goBack"
    }))));
};

export { OtherCryptoWallets };
//# sourceMappingURL=OtherWallets.mjs.map
